
export default {
  name: 'ProductListCategoryHeader',
  props: {
    header: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    hasSpecialPrices: {
      type: Boolean,
      default: null
    }
  }
}
